import { GET_GIFT } from '../constant/eventbus';
import { openLink } from '../tools/mgtv/link';
import { getYuyueInfo, getAward, appointment, getFzsToken, getAwardRecv } from '../api/index';
import process_award from '../tools/mgtv/process_award';
import Storage from '../tools/storage';
import { FZSSTORAGE } from '../constant/localstorageKeys';
import { isFunction } from '../tools/typeof';
import { click_event } from '../tools/mgtv/analysis';
import { mcityInfo } from '../constant/mcity';


const fzsStorage = new Storage({
  prefix: 'vip_fzs_cache_',
  expire: 60 * 30
}); // 缓存30分钟

function jumpToFzs(awardInfo) {
  const { sign, signTime, token } = fzsStorage.get(FZSSTORAGE);
  let targetUrl = '';
  if (awardInfo.link.indexOf('?') === -1) {
    targetUrl = `${
      awardInfo.link
    }?sign=${sign}&signTime=${signTime}&token=${token}&mgtv_token=${token}`;
  } else {
    targetUrl = `${
      awardInfo.link
    }&sign=${sign}&signTime=${signTime}&token=${token}&mgtv_token=${token}`;
  }
  if (window.gact.is_app) {
    MgtvApi.jumpPage({
      url: targetUrl
    });
  } else {
    location.href = targetUrl;
  }
}

function handleFzs(awardInfo) {
  const mobile = window.$bus.user.relate_mobile;
  if (!fzsStorage.get(FZSSTORAGE)) {
    window.$act_phone_dialog
      .show({
        title: `${
          mobile
            ? `<p>尊敬的${mobile.replace(
                mobile.substring(3, 7),
                '****'
              )}用户</p><p>您将使用该手机号查询可用活动</p>`
            : `<p>绑定手机号后查询可用活动</p>`
        }`,
        button: `${mobile ? '同意授权' : '绑定手机'}`,
        hasMobile: !!mobile
      })
      .then(() => {
        if (mobile) {
          // 跳转第三方福利页面
          let appid;
          if (awardInfo.award_type === 61) {
            appid = 'phone580'; // 蜂助手特定字段
          } else {
            appid = awardInfo.channel;
          }
          getFzsToken(appid).then(res => {
            if (!res) {
              window.$toast('网络错误，请稍后重试~');
              return;
            }
            const data = res.data;
            if (res.code == 0) {
              fzsStorage.set(FZSSTORAGE, {
                sign: data.sign,
                token: data.token,
                signTime: data.signTime
              });
              jumpToFzs(awardInfo);
            } else {
              window.$toast(res.msg);
            }
          });
        } else {
          // 跳转到绑定手机页面
          MgtvApi.jumpPage({
            url: 'https://app.hitv.com/passport/cn/iphone/bindphone/index.html'
          });
        }
      });
  } else {
    jumpToFzs(awardInfo);
  }
}

function handleInfinit(awardInfo) {
  if (window.gact.is_app) {
    MgtvApi.jumpPage({
      url: awardInfo.link
    });
  } else {
    location.href = awardInfo.link;
  }
}
function handleMcityGift(act_name, awardInfo, callback) {
  handleMcity(act_name, awardInfo).then((mobile) => {
    getAward(awardInfo, act_name,mobile).then(res => {
      if (!res) {
        return;
      }
      if (res.ret === 0) {
        const award_info = res.data;
        click_event(award_info.award_name, award_info.award_id);
        // Mcity奖品展示预约弹窗
        if (!res) {
          window.$toast('请求超时');
          return 'fail';
        }
        if (res.ret === 0) {
          window.$toast('领取成功');
          awardInfo.received = 2;
          showMcityDialog(mobile,awardInfo)
          isFunction(callback) && callback(awardInfo);
        } else {
          res.msg && window.$toast(res.msg);
        }
        awardInfo.received = 1;
        isFunction(callback) && callback(awardInfo);
      } else {
        window.$toast(res.msg);
      }
    });
  });

}

function showMcityDialog(mobile,award_info) {
  window.$dialog.confirm({
    message: `${mobile ? '手机用户：'+ mobile:''}<br/>您是否要去Mcity小程序<br/>兑换${award_info.award_name}？`,
    title:'预约信息确认',
    cancelButtonText:'再看看其他权益',
    confirmButtonText:'去兑换',
    confirmButtonColor:'#333'
  }).then(()=>{
    award_info.link && openLink(award_info.link)
  }).catch(() => {
    console.log('取消')
  });
}

function handleMcity(act_name, award_info) {
  const yuYueInfo = {}; // 个人预约信息
  // 获取预约信息
  return getAwardRecv(act_name, award_info.award_id)
    .then(res => {
      // 已领取
      if (res && res.ret === 0 && res.data.already_get) {
        yuYueInfo.mobile = res.data.note;
        yuYueInfo.already_get = res.data.already_get;
      }
      return yuYueInfo;
    })
    .then(yuYueInfo => {
      if (yuYueInfo.mobile) {
        // 展示预约信息确认
        showMcityDialog(yuYueInfo.mobile,award_info)
      } else {
        // 弹出填写手机号弹窗
        if(yuYueInfo.already_get){
          // 老版本，已领取，但是没有填写手机号，再预约一次
          showMcityDialog(yuYueInfo.mobile,award_info)
        }else {
          const info = mcityInfo.find(item => {
            return item.award_id == award_info.award_id
          }) || {}
          return window.$act_mcity_dialog.show({
            title: `${info.award_info ? info.award_info :'请输入手机号领取'}`,
            button: '确认领取',
            // onlyCs: award_info.award_id == 9089 || award_info.award_id == 9088 ? true : false, //只有长沙店有优惠券 //  部分奖品没有门店选取，暂时先用奖品ID来做区分。ID由运营配置出来给到
            // yuyueMobile: '',
            // yuyueCity: yuYueInfo.city
          });
        }

      }
    })
    .then(res => {
      // 提交预约信息
      if(!res){
        return new Promise((resolve,reject) => {
          // resolve(false)
          reject(false)
        })
      }
      const mobile = res.info.find((item => item.label == '手机')).value
      return mobile
    });
}

function getGift(act_name, awardInfo, callback) {
  getAward(awardInfo, act_name).then(res => {
    if (!res) {
      return;
    }
    if (res.ret === 0) {
      const award_info = res.data;
      click_event(award_info.award_name, award_info.award_id);
      if (award_info.already_get === 1) {
        //已领取过的奖品
        if (award_info.award_type === 6 || award_info.award_type === 41) {
          //如果是纯链接奖品或者小芒券，则直接打开
          openLink(award_info.link);
        } else {
          //否则去资产页
          openLink('https://d.mgtv.com/ztsP');
        }
      } else {
        awardInfo.received = 1;
        process_award(award_info);
        isFunction(callback) && callback(awardInfo);
      }
    } else {
      window.$toast(res.msg);
    }
  });
}

const EventBenefit = {
  install: function(EventBus) {
    EventBus.$on(GET_GIFT, ({ awardInfo, act_name, callback }) => {
      switch (awardInfo.award_type) {
        case 61: // 蜂助手奖品
        case 68: // 第三方授权奖品
          handleFzs(awardInfo);
          break;
        case 62: // Mcity奖品
          handleMcityGift(act_name, awardInfo, callback);
          break;
        case 67: // 无限导流奖品，不用调奖品领取接口，直接跳走
          handleInfinit(awardInfo);
          break;
        default:
          getGift(act_name, awardInfo, callback);
      }
    });
  }
};

export default EventBenefit;
